import { Dialog, Toast } from "@vant/compat";
import Cookies from "js-cookie";

const SESSION_TOKEN_KEY = "session_token";
const TOKEN_KEY = "token";

export function triggerLogin() {
  Toast.clear();
  const userAgentString = navigator.userAgent.toLowerCase();
  // 微信环境清除cookies,刷新页面进行登录

  if (userAgentString.indexOf("micromessenger") >= 0) {
    // 清除Token
    Cookies.remove(TOKEN_KEY, { domain: ".zsnews.cn" });
    Cookies.remove(TOKEN_KEY);

    // 清除预览preview_token
    Cookies.remove("preview_token", { domain: ".zsnews.cn" });
    Cookies.remove("preview_token");

    console.log("微信环境Cookies", Cookies.get(TOKEN_KEY));

    Dialog.alert({
      title: "登录已过期，请刷新页面重新登录！"
    }).then(() => {
      location.reload();
    });
  }

  // app环境，重新调用桥接设置sessionToken
  else if (userAgentString.indexOf("zsrbapp") >= 0) {
    // 清除用户信息
    sessionStorage.removeItem(SESSION_TOKEN_KEY);

    return new Promise((resolve) => {
      try {
        window.ZsrbApp.call("userInfo", { isNeedBind: 0 }, (res) => {
          console.log(
            "userInfo本地token",
            sessionStorage.getItem(SESSION_TOKEN_KEY)
          );
          const info = JSON.parse(res);
          const sessionToken = info.sessionToken || null;
          if (sessionToken) {
            // 设置 session_token 到 sessionStorage

            console.log("userInfo后端返回info.sessionToken", info.sessionToken);
            sessionStorage.setItem(SESSION_TOKEN_KEY, sessionToken);
            Toast.success("已登录，请重试");
            resolve(true);
          } else {
            bridgeLogin(resolve);
          }
        });
      } catch {
        resolve(false);
      }
    });
  }
  // 浏览器环境
  else {
    Toast.fail("请在中山+App或微信环境中操作！");
    return Promise.resolve(false);
  }
}

const bridgeLogin = (resolve) => {
  console.log(
    "bridgeLogin本地token",
    sessionStorage.getItem(SESSION_TOKEN_KEY)
  );
  window.ZsrbApp.call("login", {}, (res) => {
    const info = JSON.parse(res);
    if (info.status == "1") {
      console.log("bridgeLogin后端返回info.sessionToken", info.sessionToken);
      sessionStorage.setItem(SESSION_TOKEN_KEY, info.sessionToken);
      Toast.success("已重新登录，请重试");
      resolve(true);
    } else {
      Dialog.alert({
        message: "当前未登录状态，请重新登录"
      }).then(() => {
        resolve(false);
      });
    }
  });
};
